import { render, staticRenderFns } from "./KeywordsMenu.vue?vue&type=template&id=5be7145a&scoped=true&"
import script from "./KeywordsMenu.vue?vue&type=script&lang=js&"
export * from "./KeywordsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be7145a",
  null
  
)

export default component.exports